import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50">
          <div className="max-w-md w-full bg-white shadow-lg rounded-lg p-8 text-center">
            <div className="text-red-500 text-6xl mb-4">⚠️</div>
            <h1 className="text-2xl font-bold text-gray-800 mb-4">
              Etwas ist schiefgelaufen
            </h1>
            <p className="text-gray-600 mb-6">
              Die Seite konnte leider nicht geladen werden. Bitte versuchen Sie es erneut.
            </p>
            <button
              onClick={() => window.location.href = '/'}
              className="bg-[#0F3D2E] text-white px-6 py-3 rounded-lg hover:bg-[#145240] transition-colors"
            >
              Zurück zur Startseite
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
